<!-- Header section with the title on the left and the period selector on the right. Below them a page section menu.-->

<div class="sticky-wrapper">
  <div class="page-header-container">
    <div class="title-and-period-selector">
      <div class="h1-medium">Incidents</div>

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-select placeholder="Select date range" [(value)]="selectedRangeValue">
          <mat-select-trigger>
            {{ selectedPeriodDisplayValue }}
          </mat-select-trigger>

          @for (option of dateRangeOptions; track option) {
            <mat-option [value]="option.value" (click)="onRangeSelectAsync(option.value)">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
        <div matPrefix>
          <mat-icon class="calendar-icon">calendar_today</mat-icon>
        </div>
      </mat-form-field>
    </div>

    <app-section-menu
      [menuItems]="{
        'Incident count': 'incident-count',
        Motivation: 'motivation',
        'Geo-locations': 'geo-locations',
        'Affected entity': 'affected-entity',
        RIMS: 'rims',
        'Threat actor': 'threat-actor',
      }"
    />
  </div>
</div>

<div class="incident-counts-text">
  Selected period incidents: {{ insightsPageStore.selectedPeriodIncidentsCount() }}
</div>

<!-- Incidents count line chart -->
@if (incidentCountsLinechart) {
  <section class="section-box" id="incident-count">
    <div class="section-title">Incident count</div>

    <div class="plot-content-container">
      <div class="plot-content-buttons">
        <button
          class="plot-content-button all-data-button-sizing"
          (click)="
            allDataClickedAsync({
              title: 'Incident count',
              chartType: InsightsChartType.incidentCounts,
              subTitle: 'Incidents by period',
              labelColumnName: 'Period',
              excludeColumns: ['percentage', 'aggregation'],
              data: insightsPageStore.incidentCountsToAllData(),
            })
          "
        >
          <mat-icon>format_list_bulleted</mat-icon>
          All data
        </button>

        <button [matMenuTriggerFor]="menu" class="plot-content-button options-button-sizing">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #menu="matMenu" class="options-menu-buttons">
          <!-- <button mat-menu-item>
            <mat-icon>content_copy</mat-icon>
            <span>Copy image</span>
          </button> -->
          <button
            mat-menu-item
            (click)="
              downloadAsPngClickedAsync({
                chartType: InsightsChartType.incidentCounts,
                captureElement: incidentCountCapture,
              })
            "
          >
            <mat-icon>file_download</mat-icon>
            <span>Download as PNG</span>
          </button>
          <button
            mat-menu-item
            (click)="
              downloadAsCsvClickedAsync({
                chartType: InsightsChartType.incidentCounts,
                labelColumnName: 'Period',
                data: insightsPageStore.incidentCountsToAllData(),
              })
            "
          >
            <mat-icon>file_download</mat-icon>
            <span>Download as CSV</span>
          </button>
        </mat-menu>
      </div>

      <div #incidentCountCapture>
        <div class="chart-container chart--line">
          <div class="chart__plot">
            <plotly-plot
              #incidentCount
              [data]="incidentCountsLinechart.data"
              [layout]="incidentCountsLinechart.layout"
              [config]="incidentCountsLinechart.config"
            ></plotly-plot>
          </div>

          @if (showIncidentCountsLineChartLegend) {
            <div class="chart__legend">
              <app-plot-legend
                [title]="'Compare periods'"
                [data]="incidentCountsLinechartData"
                [labelOnly]="true"
                [static]="false"
                (rowClicked)="incidentsCountLegendRowClicked($event, incidentCount)"
              >
              </app-plot-legend>
            </div>
          }
        </div>
      </div>
    </div>
  </section>
}

<!-- Motivation pie chart -->
@if (incidentsByMotivationPieChart) {
  <section class="section-box" id="motivation">
    <div class="section-title">Motivation</div>
    <app-piechart-plot
      [plotlyData]="incidentsByMotivationPieChart!"
      [legendData]="incidentsByMotivationPieChartData"
      [chartType]="InsightsChartType.incidentsByMotivation"
      plotLabel="Motivation type"
      [allData]="insightsPageStore.incidentsToMotivationToAllData()"
      (downloadPng)="downloadAsPngClickedAsync($event)"
      (downloadCsv)="downloadAsCsvClickedAsync($event)"
      (allDataClick)="allDataClickedAsync($event)"
    />
  </section>
}

<!-- Geo-locations -->
<ng-template #geoLocationMapPlot let-data>
  <div class="plot-content-container">
    <div class="plot-content-buttons">
      <button [matMenuTriggerFor]="menu" class="plot-content-button options-button-sizing">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #menu="matMenu" class="options-menu-buttons">
        <!-- <button mat-menu-item>
          <mat-icon>content_copy</mat-icon>
          <span>Copy image</span>
        </button> -->
        <button
          mat-menu-item
          (click)="downloadAsPngNativePlotlyClickedAsync(InsightsChartType.geoLocationsMap, geoLocationsPlotlyElement)"
        >
          <mat-icon>file_download</mat-icon>
          <span>Download as PNG</span>
        </button>
      </mat-menu>
    </div>

    <div #geoLocationsMapCapture>
      <div class="chart-container chart--choropleth">
        <div class="chart__plot--choropleth">
          <plotly-plot #geoLocationsPlotlyElement [data]="data.data" [layout]="data.layout" [config]="data.config">
          </plotly-plot>

          <div class="map-zoom-controls">
            <button mat-icon-button type="button" class="restore-zoom" (click)="onGeoLocationsMapZoomResetClicked()">
              <mat-icon>zoom_in_map</mat-icon>
            </button>
            <div class="zoom-buttons-container">
              <button mat-icon-button type="button" class="zoom-in" (click)="onGeoLocationsMapZoomInClicked()">
                <mat-icon>add</mat-icon>
              </button>
              <button mat-icon-button type="button" class="zoom-out" (click)="onGeoLocationsMapZoomOutClicked()">
                <mat-icon>remove</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<section class="section-box" id="geo-locations">
  <div class="section-title">Geo-locations</div>
  @if (geoLocationsMap) {
    <mat-tab-group
      fitInkBarToContent
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      style="width: 100%"
      (selectedTabChange)="onContinentSelectedTabChange($event)"
    >
      @for (geoLocationTab of geoLocationsMapTabLabels; track $index) {
        <mat-tab [label]="geoLocationTab">
          <!-- Template is needed to force lazy-loading of tab content -->
          <ng-template matTabContent>
            <ng-container *ngTemplateOutlet="geoLocationMapPlot; context: { $implicit: geoLocationsMap }">
            </ng-container>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>

    <mat-tab-group fitInkBarToContent mat-stretch-tabs="false" mat-align-tabs="start">
      @if (geoLocationsCountriesPieChart) {
        <mat-tab label="By country">
          <ng-template matTabContent>
            <app-piechart-plot
              [plotlyData]="geoLocationsCountriesPieChart!"
              [legendData]="geoLocationsCountriesPieChartData"
              [chartType]="InsightsChartType.geoLocationsCountries"
              plotLabel="Country"
              [allData]="insightsPageStore.geoLocationsCountriesToAllData()"
              (downloadPng)="downloadAsPngClickedAsync($event)"
              (downloadCsv)="downloadAsCsvClickedAsync($event)"
              (allDataClick)="allDataClickedAsync($event)"
            />
          </ng-template>
        </mat-tab>
      }
      @if (geoLocationsContinentsPieChart) {
        <mat-tab label="By continent">
          <ng-template matTabContent>
            <app-piechart-plot
              [plotlyData]="geoLocationsContinentsPieChart!"
              [legendData]="geoLocationsContinentsPieChartData"
              [chartType]="InsightsChartType.geoLocationsContinents"
              plotLabel="Continent"
              [allData]="insightsPageStore.geoLocationsContinentsToAllData()"
              (downloadPng)="downloadAsPngClickedAsync($event)"
              (downloadCsv)="downloadAsCsvClickedAsync($event)"
              (allDataClick)="allDataClickedAsync($event)"
            />
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  }
</section>

<!-- Affected entity pie charts -->
<section class="section-box" id="affected-entity">
  <div class="section-title">Affected entity</div>
  <mat-tab-group fitInkBarToContent mat-stretch-tabs="false" mat-align-tabs="start">
    @if (incidentsByBusinessSectorPieChart) {
      <mat-tab label="Business sector">
        <ng-template matTabContent>
          <app-piechart-plot
            [plotlyData]="incidentsByBusinessSectorPieChart!"
            [legendData]="incidentsByBusinessSectorPieChartData"
            [chartType]="InsightsChartType.incidentsByBusinessSector"
            plotLabel="Business sector type"
            [allData]="insightsPageStore.incidentsByBusinessSectorToAllData()"
            (downloadPng)="downloadAsPngClickedAsync($event)"
            (downloadCsv)="downloadAsCsvClickedAsync($event)"
            (allDataClick)="allDataClickedAsync($event)"
          >
          </app-piechart-plot>
        </ng-template>
      </mat-tab>
    }
    @if (incidentsByEntitySizePieChart) {
      <mat-tab label="Entity size">
        <ng-template matTabContent>
          <app-piechart-plot
            [plotlyData]="incidentsByEntitySizePieChart!"
            [legendData]="incidentsByEntitySizePieChartData"
            [chartType]="InsightsChartType.incidentsByEntitySize"
            plotLabel="Entity size type"
            [allData]="insightsPageStore.incidentsByEntitySizeToAllData()"
            (downloadPng)="downloadAsPngClickedAsync($event)"
            (downloadCsv)="downloadAsCsvClickedAsync($event)"
            (allDataClick)="allDataClickedAsync($event)"
          >
          </app-piechart-plot>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
</section>

<!-- RIMS pie charts -->
<section class="section-box" id="rims">
  <div class="section-title">RIMS</div>
  <mat-tab-group fitInkBarToContent mat-stretch-tabs="false" mat-align-tabs="start">
    @if (rimsTechnicalInitialAccessPieChart) {
      <mat-tab label="Technical initial access">
        <ng-template matTabContent>
          <app-piechart-plot
            [plotlyData]="rimsTechnicalInitialAccessPieChart!"
            [legendData]="rimsTechnicalInitialAccessPieChartData"
            [chartType]="InsightsChartType.rimsTechnicalInitialAccess"
            plotLabel="Technical initial access"
            [allData]="insightsPageStore.rimsStepsByPhases_TechnicalInitialAccess_ToAllData()"
            (downloadPng)="downloadAsPngClickedAsync($event)"
            (downloadCsv)="downloadAsCsvClickedAsync($event)"
            (allDataClick)="allDataClickedAsync($event)"
          >
          </app-piechart-plot>
        </ng-template>
      </mat-tab>
    }
    @if (rimsPostExploitationPieChart) {
      <mat-tab label="Post exploitation">
        <ng-template matTabContent>
          <app-piechart-plot
            [plotlyData]="rimsPostExploitationPieChart!"
            [legendData]="rimsPostExploitationPieChartData"
            [chartType]="InsightsChartType.rimsPostExploitation"
            plotLabel="Post exploitation"
            [allData]="insightsPageStore.rimsStepsByPhases_PostExploitation_ToAllData()"
            (downloadPng)="downloadAsPngClickedAsync($event)"
            (downloadCsv)="downloadAsCsvClickedAsync($event)"
            (allDataClick)="allDataClickedAsync($event)"
          >
          </app-piechart-plot>
        </ng-template>
      </mat-tab>
    }
    @if (rimsTechnicalImpactPieChart) {
      <mat-tab label="Technical impact">
        <ng-template matTabContent>
          <app-piechart-plot
            [plotlyData]="rimsTechnicalImpactPieChart!"
            [legendData]="rimsTechnicalImpactPieChartData"
            [chartType]="InsightsChartType.rimsTechnicalImpact"
            plotLabel="Technical impact"
            [allData]="insightsPageStore.rimsStepsByPhases_TechnicalImpact_ToAllData()"
            (downloadPng)="downloadAsPngClickedAsync($event)"
            (downloadCsv)="downloadAsCsvClickedAsync($event)"
            (allDataClick)="allDataClickedAsync($event)"
          >
          </app-piechart-plot>
        </ng-template>
      </mat-tab>
    }
    @if (rimsNonTechnicalImpactPieChart) {
      <mat-tab label="Non-technical impact">
        <ng-template matTabContent>
          <app-piechart-plot
            [plotlyData]="rimsNonTechnicalImpactPieChart!"
            [legendData]="rimsNonTechnicalImpactPieChartData"
            [chartType]="InsightsChartType.rimsNonTechnicalImpact"
            plotLabel="Non-technical impact"
            [allData]="insightsPageStore.rimsStepsByPhases_NonTechnicalImpact_ToAllData()"
            (downloadPng)="downloadAsPngClickedAsync($event)"
            (downloadCsv)="downloadAsCsvClickedAsync($event)"
            (allDataClick)="allDataClickedAsync($event)"
          >
          </app-piechart-plot>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
</section>

<!-- Threat actor pie chart -->
@if (incidentsByThreatActorPieChart) {
  <section class="section-box" id="threat-actor">
    <div class="section-title">Threat actor</div>
    <app-piechart-plot
      [plotlyData]="incidentsByThreatActorPieChart!"
      [legendData]="incidentsByThreatActorPieChartData"
      [chartType]="InsightsChartType.incidentsByThreatActor"
      plotLabel="Threat actor"
      [allData]="insightsPageStore.incidentsByThreatActorToAllData()"
      (downloadPng)="downloadAsPngClickedAsync($event)"
      (downloadCsv)="downloadAsCsvClickedAsync($event)"
      (allDataClick)="allDataClickedAsync($event)"
    />
  </section>
}
